import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  account: {},
  isLoading: false,
  error: null,

  changePassword: {},
  errorChangePassword: null,
  isLoadingChangePassword: false,

  updateAccount: {},
  errorUpdateAccount: false,
  isLoadingUpdateAccount: false,

  editAccount: {},
  errorEditAccount: false,
  isLoadingEditAccount: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/account/index.js